import 'magnific-popup';
import 'magnific-popup/dist/magnific-popup.css';

/**
 * ポップアップ関連の処理
 */
export default class Popup {
  constructor() {
    this.article_img();
  };

  /**
   * 記事画像ポップアップ
   */
  article_img() {
    $('.wp-block-image.is-style-popup').magnificPopup({
      delegate: 'a',
      type: 'image',
      closeOnContentClick: true,
      fixedContentPos: true,
      mainClass: 'mfp-no-margins mfp-with-zoom',
      image: {
        verticalFit: true
      },
      zoom: {
        enabled: true,
        duration: 300
      }
    });
  };
}
